import AnalyticIncidentData from "../../../../../api/AnalyticIncidentData";
import { observer } from "mobx-react-lite";

export const ListIncidentCompany = observer(({ goCard }) => {
  return (
    <ul className="incident_list_wrapper">
      <li className="incident_row_container incident_header_row">
        <span className="incident_row_name_error">Ошибка</span>
        <span className="incident_row_name_count">Время простоя</span>
      </li>
      {AnalyticIncidentData.incidents.map((i) => (
        <li
          key={i.data}
          className="incident_row_container"
          onClick={() => goCard(i)}
        >
          <span className="incident_row_name_error">{i.data}</span>
          <span className="incident_row_name_count">{i.total_counter}</span>
        </li>
      ))}
    </ul>
  );
});
